<script setup lang="ts">
const store = useBigHeroBannerStore();
const props = defineProps<{
  index: number;
}>();

const totalSlides = computed(() => store.banners.length);
const active = computed(() => store.nextSlideIndex === props.index);
</script>

<template>
  <button
    type="button"
    class="dot big-hero-banner-dot"
    :class="{ active: active }"
    :title="
      $t('SV.MES_GoToSlide', {
        current: (index + 1).toString(),
        total: totalSlides.toString(),
      })
    "
    @click.stop.prevent="store.updateToSlide(index)"
  >
    <FAIcon class="fa-solid fa-circle" />
  </button>
</template>

<style scoped lang="postcss"></style>
